import { data } from './constant';
import PolicyType from '@components/PolicyType';

enum TYPE {
  text = 'Refund & Cancelation Policy',
}

const Refund = () => {
  return <PolicyType data={data} type={TYPE.text} />;
};

export default Refund;
